import React from 'react';
import { Divider, Grid, Typography, useTheme } from '@material-ui/core';
import { useStyles } from 'components/Reports';
import MaterialTable from 'material-table';
import withAppStylesGrid from 'HOCs/withAppStyles';

const HistoricalReports = () => {
    const classes = useStyles();
    const theme = useTheme();
    const DataGrid = withAppStylesGrid(MaterialTable, 
        { 
            getRecords: [],
            theme,
            defaultFilters: {}
        }
    );
    return (
        <Grid item >
            <Typography variant="h4" color="primary">Historical Reports Results</Typography>
            <Divider />
            <div className={classes.generatorForm} >
                <DataGrid 
                title="Reports"
                options={{ search: false }} 
                columns={[
                    {title: "Report Type", field: "ReportName"},
                    {title: "Date Run", field: "DateRun"},
                    {title: "Download", field: "Download"}
                ]}
                />
            </div>
        </Grid>
    )
};

export default HistoricalReports;

